import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Header, InputPinCode, Text } from '~/atomic';
import { useAppDispatch, useAppSelector } from '~/store';
import { selectRecovery } from '~/store/recovery/selectors';
import { verifyPasswordResetPin } from '~/store/recovery/thunks';

export default function PinView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { email } = useAppSelector(selectRecovery);
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    if (pin.length < 6) return;
    if (!email) {
      navigate('/auth/recovery/email', { replace: true });
      return;
    }
    setLoading(true);
    const ok = await dispatch(
      verifyPasswordResetPin({ email, code: pin }),
    ).unwrap();
    setLoading(false);
    if (ok) navigate('/auth/recovery/new-password');
    else setPin('');
  };

  return (
    <div className="min-h-screen bg-intense-01 flex flex-col">
      <Header title="Confirmar PIN" />
      <Box className="flex-1 w-full xl:max-w-[440px] mx-auto px-small py-medium flex flex-col gap-medium">
        <Box>
          <Text className="text-headingH1 color-complement-01" as="h1">
            Confirme o código
          </Text>
          <Text className="mt-quark text-bodyMD color-intense-06">
            Enviamos um código de 6 dígitos {email ? `para ${email}` : 'para seu e-mail'}.
          </Text>
        </Box>
        <InputPinCode value={pin} onChange={setPin} length={6} autoFocus />
        <Button
          onClick={confirm}
          fullWidth
          loading={loading}
          text="Confirmar"
          rightIcon="icon-arrow-right"
          disabled={pin.length < 6}
        />
      </Box>
    </div>
  );
}
